import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import InvoiceModal from '../../components/admin/InvoiceModal';
import { posApi } from '../../services/api';

export default function POSPage() {
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [packages, setPackages] = useState([]);
  const [cart, setCart] = useState([]);
  const [customer, setCustomer] = useState({ customer_name: '', customer_phone: '', customer_email: '', customer_address: '', notes: '', preferred_day: '', preferred_time: '', payment_method: 'cash' });
  const [selectedCategory, setSelectedCategory] = useState('');
  const [tab, setTab] = useState('items');
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [discountAmount, setDiscountAmount] = useState(0);
  const [showInvoice, setShowInvoice] = useState(false);
  const [lastOrder, setLastOrder] = useState(null);
  const [customerHistory, setCustomerHistory] = useState(null);
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState('');

  const fetchData = async () => {
    try {
      const [cRes, iRes, pRes] = await Promise.all([
        posApi.categories.list({ per_page: 50, is_active: 1 }),
        posApi.items.list({ per_page: 200, is_active: 1 }),
        posApi.packages.list({ per_page: 50, is_active: 1 }),
      ]);
      setCategories(cRes.data.data?.data || cRes.data.data || []);
      setItems(iRes.data.data?.data || iRes.data.data || []);
      setPackages(pRes.data.data?.data || pRes.data.data || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchData(); }, []);

  const lookupCustomer = async (phone) => {
    if (!phone || phone.length < 6) { setCustomerHistory(null); return; }
    try {
      const res = await posApi.orders.list({ customer_phone: phone, per_page: 5 });
      const orders = res.data.data?.data || res.data.data || [];
      if (orders.length > 0) {
        setCustomerHistory({ count: orders.length, last_order: orders[0].created_at, last_name: orders[0].customer_name });
        if (!customer.customer_name && orders[0].customer_name) {
          setCustomer(prev => ({ ...prev, customer_name: orders[0].customer_name }));
        }
      } else { setCustomerHistory(null); }
    } catch { setCustomerHistory(null); }
  };

  const handlePhoneChange = (value) => {
    setCustomer(prev => ({ ...prev, customer_phone: value }));
    if (window._phoneTimer) clearTimeout(window._phoneTimer);
    window._phoneTimer = setTimeout(() => lookupCustomer(value), 600);
  };

  let filteredItems = selectedCategory ? items.filter(i => i.category_id === parseInt(selectedCategory)) : items;
  if (search) {
    const q = search.toLowerCase();
    filteredItems = filteredItems.filter(i =>
      (i.name || '').toLowerCase().includes(q) ||
      String(i.price || i.base_price || 0).includes(q) ||
      (i.category?.name || '').toLowerCase().includes(q)
    );
  }

  const filteredPackages = packages.filter(p => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (p.name || '').toLowerCase().includes(q) ||
      String(p.base_price || 0).includes(q) ||
      (p.short_description || p.description || '').toLowerCase().includes(q);
  });

  const addToCart = (item, type = 'item') => {
    setCart(prev => {
      const existing = prev.find(ci => ci.itemable_type === type && ci.itemable_id === item.id);
      if (existing) return prev.map(ci => ci.itemable_type === type && ci.itemable_id === item.id ? { ...ci, quantity: ci.quantity + 1 } : ci);
      return [...prev, { itemable_type: type, itemable_id: item.id, name: item.name, price: item.base_price || item.price || 0, quantity: 1 }];
    });
  };

  const updateCartQty = (idx, qty) => { if (qty < 1) return; setCart(prev => prev.map((ci, i) => i === idx ? { ...ci, quantity: qty } : ci)); };
  const removeFromCart = (idx) => setCart(prev => prev.filter((_, i) => i !== idx));

  const subtotal = cart.reduce((sum, ci) => sum + (ci.price * ci.quantity), 0);
  const taxAmount = cart.reduce((sum, ci) => {
    const pkg = packages.find(p => p.id === ci.itemable_id && ci.itemable_type === 'package');
    if (pkg && pkg.tax_percent > 0) return sum + (ci.price * ci.quantity * pkg.tax_percent / 100);
    return sum;
  }, 0);
  const total = Math.max(0, subtotal + taxAmount - discountAmount);

  const validate = () => {
    const errs = {};
    if (cart.length === 0) errs.cart = 'Tambahkan minimal 1 item/paket';
    if (!customer.customer_name || !customer.customer_name.trim()) errs.customer_name = 'Nama wajib diisi';
    if (!customer.customer_phone || !customer.customer_phone.trim()) errs.customer_phone = 'Nomor telepon wajib diisi';
    else if (!/^[0-9+\-\s]{6,20}$/.test(customer.customer_phone.trim())) errs.customer_phone = 'Format telepon tidak valid (min 6 digit)';
    if (customer.customer_email && customer.customer_email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.customer_email.trim())) errs.customer_email = 'Format email tidak valid';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSaving(true);
    try {
      const res = await posApi.orders.create({
        customer_name: customer.customer_name.trim(),
        customer_phone: customer.customer_phone.trim(),
        customer_email: customer.customer_email.trim() || null,
        customer_address: customer.customer_address.trim(),
        notes: customer.notes.trim(),
        preferred_day: customer.preferred_day || null,
        preferred_time: customer.preferred_time || null,
        payment_method: customer.payment_method,
        discount_amount: discountAmount,
        referral_code: 'SystemDev',
        items: cart.map(ci => ({
          itemable_type: ci.itemable_type === 'package' ? 'service_package' : 'service_item',
          itemable_id: ci.itemable_id,
          quantity: ci.quantity,
          unit_price: ci.price,
        })),
      });
      const created = res.data.data;
      setLastOrder(created);
      setCart([]);
      setDiscountAmount(0);
      setCustomer({ customer_name: '', customer_phone: '', customer_email: '', customer_address: '', notes: '', preferred_day: '', preferred_time: '', payment_method: 'cash' });
      setCustomerHistory(null);
      setErrors({});
      setSuccessMsg('✅ Pesanan berhasil dibuat!');
      setTimeout(() => setSuccessMsg(''), 3000);
      setShowInvoice(true);
    } catch (err) {
      alert(err.response?.data?.message || 'Gagal membuat pesanan');
    } finally {
      setSaving(false);
    }
  };

  const formatPrice = (p) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(p);

  return (
    <AdminLayout>
      <div className="h-full flex flex-col" style={{ minHeight: 'calc(100vh - 98px)' }}>
        <h1 className="text-lg font-semibold text-gray-800 mb-0.5">Point Of Sales</h1>
        <p className="text-[11px] text-gray-500 mb-3">Pilih item/paket, isi data pelanggan, lalu buat pesanan.</p>
        {successMsg && (
          <div className="mb-2 p-3 bg-green-50 border border-green-200 text-green-700 rounded-xl text-xs font-medium">{successMsg}</div>
        )}
        <div className="flex-1 grid grid-cols-1 lg:grid-cols-4 gap-3 min-h-0">
          {/* LEFT: Items grid — 3 cols */}
          <div className="lg:col-span-3 flex flex-col min-h-0">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 flex flex-col flex-1 min-h-0">
              {/* Search + Tabs + Category filter */}
              <div className="flex items-center gap-3 mb-2 flex-shrink-0">
                <input
                  type="text"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="🔍 Cari nama, harga, atau kategori..."
                  className="flex-1 border border-gray-200 rounded-lg px-3 py-1.5 text-[11px] focus:ring-2 focus:ring-brand outline-none bg-gray-50 focus:bg-white transition-colors"
                />
                <button onClick={() => setTab('items')} className={`px-3 py-1.5 rounded-lg text-[11px] font-semibold transition-colors whitespace-nowrap ${tab === 'items' ? 'bg-brand text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>📦 Item</button>
                <button onClick={() => setTab('packages')} className={`px-3 py-1.5 rounded-lg text-[11px] font-semibold transition-colors whitespace-nowrap ${tab === 'packages' ? 'bg-brand text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>🎁 Paket</button>
                {tab === 'items' && (
                  <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="border border-gray-200 rounded-lg px-2 py-1.5 text-[11px] bg-white focus:ring-2 focus:ring-primary outline-none">
                    <option value="">📂 Semua</option>
                    {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                )}
              </div>
              
              {/* Items grid */}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 flex-1 overflow-y-auto pr-1 min-h-0">
                {tab === 'items' && filteredItems.map(item => (
                  <div key={item.id} className="relative group/item">
                    <button onClick={() => addToCart(item, 'item')} className="w-full text-left p-4 border border-gray-200 rounded-xl hover:border-brand hover:bg-brand/5 transition-all hover:shadow-md cursor-pointer">
                      <div className="flex items-start gap-3 mb-3">
                        {item.image_url ? <img src={item.image_url} alt={item.name} className="w-12 h-12 rounded-lg object-cover flex-shrink-0 bg-gray-100" /> : <span className="w-12 h-12 rounded-lg bg-brand/10 flex items-center justify-center text-2xl flex-shrink-0">{item.icon || '📦'}</span>}
                        <div className="min-w-0 flex-1"><p className="text-sm font-semibold text-gray-800 truncate group-hover/item:text-brand transition-colors">{item.name}</p><p className="text-xs text-gray-400 truncate mt-0.5">{item.category?.name || ''}</p></div>
                      </div>
                      <div className="flex items-center justify-between"><span className="text-base font-bold text-navy">{formatPrice(item.price)}</span>{item.badge && <span className="px-2 py-0.5 text-[10px] bg-yellow-100 text-yellow-700 rounded-full font-semibold">{item.badge}</span>}</div>
                    </button>
                    {/* Hover tooltip ABOVE card */}
                    {(item.description || item.notes || item.duration_minutes > 0) && (
                      <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1.5 z-50 opacity-0 invisible group-hover/item:opacity-100 group-hover/item:visible transition-all duration-150 pointer-events-none">
                        <div className="bg-gray-900 text-white text-[10px] rounded-lg px-2.5 py-1.5 shadow-xl max-w-44 whitespace-normal leading-tight text-center">
                          {(item.description || item.notes) ? <p className="line-clamp-3">{item.description || item.notes}</p> : null}
                          {item.duration_minutes > 0 && <p className={(item.description || item.notes) ? 'mt-0.5 text-brand' : 'text-brand'}>⏱ {item.duration_minutes} menit</p>}
                          <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-[6px] border-transparent border-t-gray-900" />
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                {tab === 'packages' && filteredPackages.map(pkg => (
                  <div key={pkg.id} className="relative group/item">
                    <button onClick={() => addToCart(pkg, 'package')} className="w-full text-left p-4 border border-gray-200 rounded-xl hover:border-brand hover:bg-brand/5 transition-all hover:shadow-md cursor-pointer">
                      <div className="flex items-start gap-3 mb-3">
                        {pkg.image_url ? <img src={pkg.image_url} alt={pkg.name} className="w-12 h-12 rounded-lg object-cover flex-shrink-0 bg-gray-100" /> : <span className="w-12 h-12 rounded-lg bg-brand/10 flex items-center justify-center text-2xl flex-shrink-0">{pkg.icon || '🎁'}</span>}
                        <div className="min-w-0 flex-1"><p className="text-sm font-semibold text-gray-800 truncate group-hover/item:text-brand transition-colors">{pkg.name}</p><p className="text-xs text-gray-400 truncate mt-0.5">{pkg.short_description || pkg.description || ''}</p></div>
                      </div>
                      <div className="flex items-center justify-between"><span className="text-base font-bold text-navy">{formatPrice(pkg.base_price)}</span>{pkg.tax_percent > 0 && <span className="text-xs text-gray-400">+PPN {pkg.tax_percent}%</span>}</div>
                    </button>

                    {/* Hover tooltip ABOVE card */}
                    {(pkg.description || (pkg.items && pkg.items.length > 0)) && (
                      <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1.5 z-50 opacity-0 invisible group-hover/item:opacity-100 group-hover/item:visible transition-all duration-150 pointer-events-none">
                        <div className="bg-gray-900 text-white text-[10px] rounded-lg px-2.5 py-1.5 shadow-xl max-w-48 whitespace-normal leading-tight">
                          {pkg.description && <p className="line-clamp-2 mb-1">{pkg.description}</p>}
                          {pkg.items && pkg.items.length > 0 && (
                            <div>
                              <p className="text-white font-semibold mb-0.5">🛠 {pkg.items.length} item</p>
                              <ul className="space-y-0.5 max-h-20 overflow-y-auto">
                                {pkg.items.slice(0, 4).map((pi, idx) => (
                                  <li key={idx} className="flex items-center gap-1 text-gray-300">
                                    <span className="w-1 h-1 bg-brand rounded-full flex-shrink-0" />
                                    <span className="truncate">{pi.name || pi.item?.name || 'Item'}</span>
                                    {pi.quantity > 1 && <span className="text-gray-500 flex-shrink-0">×{pi.quantity}</span>}
                                  </li>
                                ))}
                                {pkg.items.length > 4 && <li className="text-gray-500 text-[9px]">+{pkg.items.length - 4} lainnya</li>}
                              </ul>
                            </div>
                          )}
                          {pkg.tax_percent > 0 && <p className="mt-1 text-yellow-400 text-[9px]">+PPN {pkg.tax_percent}%</p>}
                          <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-[6px] border-transparent border-t-gray-900" />
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                {tab === 'items' && filteredItems.length === 0 && <p className="text-gray-400 col-span-full text-center py-12 text-sm">Tidak ada item{selectedCategory ? ' di kategori ini' : search ? ' dengan kata kunci "'+search+'"' : ''}</p>}
                {tab === 'packages' && filteredPackages.length === 0 && <p className="text-gray-400 col-span-full text-center py-12 text-sm">Tidak ada paket{search ? ' dengan kata kunci "'+search+'"' : ''}</p>}
              </div>
            </div>
          </div>

          {/* RIGHT: Cart + Customer (compact) */}
          <div className="lg:col-span-1 flex flex-col gap-2 min-h-0">
            {/* Cart */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 flex flex-col flex-shrink-0" style={{ maxHeight: '45%' }}>
              <h2 className="font-bold text-gray-800 mb-1.5 flex items-center gap-1.5 text-xs">🛒 Keranjang <span className="text-[10px] font-normal text-gray-400">({cart.length})</span></h2>
              {errors.cart && <p className="text-[9px] text-red-500 mb-1">{errors.cart}</p>}
              {cart.length === 0 ? <p className="text-[10px] text-gray-400 text-center py-4">Klik item/paket</p> : (<>
                <div className="space-y-1 mb-2 flex-1 overflow-y-auto min-h-0">
                  {cart.map((ci, idx) => (
                    <div key={idx} className="flex items-center justify-between bg-gray-50 p-1.5 rounded-lg">
                      <div className="min-w-0 flex-1 mr-1">
                        <p className="text-[10px] font-medium text-gray-800 truncate">{ci.name}</p>
                        <p className="text-[9px] text-navy font-mono">{formatPrice(ci.price)} × {ci.quantity}</p>
                      </div>
                      <div className="flex items-center gap-0.5 shrink-0">
                        <button onClick={() => updateCartQty(idx, ci.quantity - 1)} className="w-5 h-5 rounded bg-gray-200 text-gray-600 text-[10px] font-bold hover:bg-gray-300 flex items-center justify-center">−</button>
                        <span className="text-[10px] font-semibold w-5 text-center">{ci.quantity}</span>
                        <button onClick={() => updateCartQty(idx, ci.quantity + 1)} className="w-5 h-5 rounded bg-gray-200 text-gray-600 text-[10px] font-bold hover:bg-gray-300 flex items-center justify-center">+</button>
                        <button onClick={() => removeFromCart(idx)} className="ml-0.5 text-red-400 hover:text-red-600 text-[10px] font-bold px-0.5">✕</button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="border-t pt-1.5 space-y-0.5 text-[10px] flex-shrink-0">
                  <div className="flex justify-between"><span className="text-gray-500">Subtotal</span><span className="font-medium">{formatPrice(subtotal)}</span></div>
                  {taxAmount > 0 && <div className="flex justify-between"><span className="text-gray-500">Pajak</span><span className="font-medium">{formatPrice(taxAmount)}</span></div>}
                  <div className="flex justify-between items-center">
                    <span className="text-gray-500">Diskon</span>
                    <div className="flex items-center gap-0.5">
                      <span className="text-gray-400 text-[9px]">Rp</span>
                      <input
                        type="number"
                        min="0"
                        value={discountAmount || ''}
                        onChange={e => setDiscountAmount(parseFloat(e.target.value) || 0)}
                        className="w-20 border border-gray-200 rounded px-1.5 py-0.5 text-[10px] text-right font-mono focus:ring-2 focus:ring-primary outline-none"
                        placeholder="0"
                      />
                    </div>
                  </div>
                  <div className="flex justify-between text-xs font-bold border-t pt-1"><span>Total</span><span className={discountAmount > 0 ? 'text-red-600' : ''}>{formatPrice(total)}</span></div>
                </div>
              </>)}
            </div>

            {/* Customer Form */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 flex-1 overflow-y-auto min-h-0">
              <h2 className="font-bold text-gray-800 mb-1.5 text-xs flex items-center gap-1">👤 Data Pelanggan</h2>
              <form onSubmit={handleSubmit} className="space-y-2 flex flex-col flex-1">
                <div>
                  <input required value={customer.customer_name} onChange={e => setCustomer({...customer, customer_name: e.target.value})} className={`w-full border rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none ${errors.customer_name ? 'border-red-300 bg-red-50' : 'border-gray-200'}`} placeholder="Nama lengkap *" />
                  {errors.customer_name && <p className="text-[8px] text-red-500 mt-0.5">{errors.customer_name}</p>}
                </div>
                <div>
                  <input required value={customer.customer_phone} onChange={e => handlePhoneChange(e.target.value)} className={`w-full border rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none ${errors.customer_phone ? 'border-red-300 bg-red-50' : 'border-gray-200'}`} placeholder="Telepon *" />
                  {errors.customer_phone && <p className="text-[8px] text-red-500 mt-0.5">{errors.customer_phone}</p>}
                  {customerHistory && (
                    <div className="mt-1 bg-blue-50 border border-blue-100 rounded px-2 py-1 text-[9px] text-blue-700">
                      🕐 <strong>{customerHistory.count}x</strong> pesan{ customerHistory.last_order && <span className="text-blue-500 ml-1">· {new Date(customerHistory.last_order).toLocaleDateString('id-ID')}</span>}
                    </div>
                  )}
                </div>
                <div>
                  <input type="email" value={customer.customer_email} onChange={e => setCustomer({...customer, customer_email: e.target.value})} className={`w-full border rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none ${errors.customer_email ? 'border-red-300 bg-red-50' : 'border-gray-200'}`} placeholder="Email (opsional)" />
                </div>
                <div className="flex-1">
                  <textarea value={customer.customer_address} onChange={e => setCustomer({...customer, customer_address: e.target.value})} className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none resize-none" rows={2} placeholder="Alamat lengkap (opsional)" />
                </div>
                <div>
                  <textarea value={customer.notes} onChange={e => setCustomer({...customer, notes: e.target.value})} className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none resize-none" rows={2} placeholder="Catatan tambahan (opsional)" />
                </div>
                <div>
                  <label className="block text-[9px] font-semibold text-gray-500 mb-0.5">📅 Hari Pemesanan</label>
                  <select value={customer.preferred_day} onChange={e => setCustomer({...customer, preferred_day: e.target.value})} className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none bg-white">
                    <option value="">Pilih hari (opsional)</option>
                    <option value="senin">Senin</option>
                    <option value="selasa">Selasa</option>
                    <option value="rabu">Rabu</option>
                    <option value="kamis">Kamis</option>
                    <option value="jumat">Jumat</option>
                    <option value="sabtu">Sabtu</option>
                    <option value="minggu">Minggu</option>
                  </select>
                </div>
                <div>
                  <label className="block text-[9px] font-semibold text-gray-500 mb-0.5">🕐 Jam Pemesanan</label>
                  <select value={customer.preferred_time} onChange={e => setCustomer({...customer, preferred_time: e.target.value})} className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none bg-white">
                    <option value="">Pilih jam (opsional)</option>
                    <option value="08:00 - 09:00">08:00 - 09:00</option>
                    <option value="09:00 - 10:00">09:00 - 10:00</option>
                    <option value="10:00 - 11:00">10:00 - 11:00</option>
                    <option value="11:00 - 12:00">11:00 - 12:00</option>
                    <option value="13:00 - 14:00">13:00 - 14:00</option>
                    <option value="14:00 - 15:00">14:00 - 15:00</option>
                    <option value="15:00 - 16:00">15:00 - 16:00</option>
                    <option value="16:00 - 17:00">16:00 - 17:00</option>
                  </select>
                </div>
                <div>
                  <select value={customer.payment_method} onChange={e => setCustomer({...customer, payment_method: e.target.value})} className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-[10px] focus:ring-2 focus:ring-primary outline-none bg-white">
                    <option value="cash">💵 Tunai</option>
                    <option value="transfer">🏦 Transfer</option>
                    <option value="qris">📱 QRIS</option>
                    <option value="other">💳 Lainnya</option>
                  </select>
                </div>
                <button type="submit" disabled={saving || cart.length === 0} className="w-full py-2 bg-brand text-white rounded-lg text-[10px] font-bold hover:bg-brand-dark disabled:opacity-50 transition-colors">
                  {saving ? '⏳ Memproses...' : '💾 Buat Pesanan'}
                </button>
              </form>
            </div>
          </div>
        </div>

        {showInvoice && lastOrder && <InvoiceModal order={lastOrder} onClose={() => setShowInvoice(false)} showPrint={true} />}
      </div>
    </AdminLayout>
  );
}